<template>
  <div class="success-check">
    <HpIcon name="checkmark-animate" class="h-16 w-16 rounded-full bg-success p-3 text-white" />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
  .success-check {
    @apply mx-auto min-h-16 scale-0;
    animation: pop-in 200ms cubic-bezier(0.165, 0.84, 0.44, 1) 150ms forwards;
  }

  @keyframes pop-in {
    100% {
      @apply scale-100;
    }
  }

  :deep(svg) {
    fill: none;
    stroke: #ffffff;
    stroke-width: 8;
    stroke-linejoin: round;
    stroke-dasharray: 87;
    stroke-dashoffset: 87;
    animation: draw 500ms cubic-bezier(0.785, 0.135, 0.15, 0.86) 450ms forwards;
  }

  @keyframes draw {
    to {
      stroke-dashoffset: 0;
    }
  }
</style>
